import "./PEPPopup.scss";
import Button from "components/Button/Button";
import { useTranslation, Trans } from "react-i18next";

interface PEPPopupProps {
  onClick: () => void;
}
const PEPPopup = ({ onClick }: PEPPopupProps) => {
  const { t } = useTranslation();
  return (
    <div className="pep-popup-container">
      <div className="popup-container pep-popup">
        <div className="main-title">
          <Trans
            i18nKey={"popups.PEPpopup.title"}
            components={{ span: <span /> }}
          />
        </div>
        <div className="sub-title">{t("popups.PEPpopup.description1")}</div>
        <Button
          className="border-btn"
          btnName={t("buttons.cancel")}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
export default PEPPopup;
